/**
 * Initializes the generic TextInput
 *
 */
export function initZdsTextInput() {
  // Handle ClearInput function
  $('.clear_input').on('mousedown', () => {
    $('.input_field').val('');
  });

  $('.input_field').on('focus, keyup', () => {
    $('.clear_input').show();
  });

  $('.input_field').on('blur', () => {
    $('.clear_input').hide();
  });
}
